'use client';

import { css } from '@bts-web/utils-style-engine';
import { IslamicStar } from '../../assets/IslamicStar';
import { useClientUserInfo } from '../../userinfo/InitialUserInfoFetcherAndParser/utils/useClientUserInfo';

const userPillStyles = css({
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
  paddingX: 'extra_small_2',
  paddingY: 'extra_small_3',
  borderRadius: '32px',
  width: 'fit-content',
});

export const IslamicLabel = ({ text }: { text: string }) => {
  const { isIslamicUser } = useClientUserInfo();

  if (isIslamicUser) {
    return (
      <div
        className={`${userPillStyles} ${css({
          backgroundColor: 'neutrals.card_fill_primary',
          color: 'neutrals.text_primary',
          display: 'flex',
          alignItems: 'center',
          gap: 'extra_small_3',
        })}`}
      >
        <IslamicStar
          className={css({
            width: '16px',
            height: '16px',
            color: 'brand.fill_primary',
          })}
        />
        <span>{text}</span>
      </div>
    );
  }

  return null;
};
